// import React from 'react';
import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import './chart.css';

export default function Chartt() {

  const data = [
    {
      name: 'Page A',
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: 'Page B',
      uv: 3000,
      pv: 5800,
      amt: 2210,
    },
    {
      name: 'Page C',
      uv: 2000,
      pv: 1800,
      amt: 2290,
    },
    {
      name: 'Page D',
      uv: 2780,
      pv: 7800,
      amt: 2000,
    },
    {
      name: 'Page E',
      uv: 1890,
      pv: 1800,
      amt: 2181,
    },
    {
      name: 'Page F',
      uv: 2390,
      pv: 8800,
      amt: 2500,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
    {
      name: 'Page G',
      uv: 3490,
      pv: 2300,
      amt: 2100,
    },
  ];

  return (
    <>
    <div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart width={200} height={100} data={data}>
          <Line type="monotone" dataKey="pv" stroke="#8884d8" strokeWidth={2} className='chart_conten' />
        </LineChart>
      </ResponsiveContainer>
    </div>
    </>
  )
}
